import { Component, OnInit, Input } from '@angular/core';
import { ITdDataTableColumn } from '@covalent/core';
import { ApplicationTypesService } from '../../../shared/services/application-types.service';
import { ApplicationType } from '../../../shared/models/application-type.model';
import * as moment from 'moment';

@Component({
    selector: 'app-types-list',
    templateUrl: './types-list.component.html',
    styles: []
})
export class TypesListComponent implements OnInit {
    @Input() hasActionBar = true;
    public applicationTypes: Array<ApplicationType>;
    public configWidthColumns: ITdDataTableColumn[] = [
        { name: 'code', label: 'Priemonės numeris', width: 150 },
        { name: 'dotationName', label: 'Priemonės pavadinimas', width: { min: 100, max: 400 } },
        { name: 'information', label: 'Informacija apie priemonę', width: { min: 100, max: 400 } },
        { name: 'validTill', label: 'Paraiškos teikiamos iki', width: 120 },
        { name: 'notes', label: 'Pastabos', width: { min: 100, max: 400 } },
        { name: 'actions', label: 'Veiksmai', width: 150 },
        { name: 'informationUrl', label: 'Informacija', width: 100 }
    ];
    constructor(public service: ApplicationTypesService) {
    }

    ngOnInit() {
        this.service.list().subscribe(list => {
            this.applicationTypes = list;
        })
    }

    protected toShortDateString(d: Date): string {
        if (!d){
            return  null;
        }
        let dd = moment(d).add(moment().utcOffset(), 'minutes');
        return dd.format('YYYY-MM-DD');
    }

}
